var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"parent-container"},[_c('CascadeSelect',_vm._g(_vm._b({class:{ ..._vm.customInputClasses }},'CascadeSelect',{
            ..._vm.$attrs,
            ..._vm.$props,
            optionLabel: 'name',
            optionGroupLabel: 'name',
            optionValue: 'id',
            optionGroupChildren: _vm.optionGroupChildren,
            appendTo: 'body',
            placeholder: _vm.$_(
                (_vm.options || []).length === 0
                    ? _vm.mergedData['text-not-available']
                    : _vm.placeholder,
            ),
            value: _vm.options == null ? undefined : _vm.generatedValue,
            loading: _vm.query.loading,
            disabled: _vm.disabled,
            options: _vm.options,
        },false),{
            ..._vm.$listeners,
            input: ($event) => (_vm.innateValue = _vm.mapData[$event]),
        })),_c('iv-button',{staticClass:"xmark",class:{
            hide: _vm.innateValue?.id == null,
        },attrs:{"icon":"fa-solid fa-xmark","disabled":_vm.disabled,"size":"md","pill":"","variant":"light"},on:{"click":function($event){$event.stopPropagation();return _vm.doCleanValue.apply(null, arguments)}}}),(_vm.innateValue)?_c('iv-table',_vm._b({staticClass:"tree-select-table",attrs:{"hide-pagination":"","disabled":_vm.disabled,"ui-tag":{
            uiHidden: _vm.uiMetaRuleMatch('tool'),
        }},on:{"updated":_vm.tableUpdated}},'iv-table',_vm.serverTable,false)):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }